import { render, staticRenderFns } from "./ActionsDomain.vue?vue&type=template&id=3544fa6e&lang=pug&"
import script from "./ActionsDomain.vue?vue&type=script&lang=js&"
export * from "./ActionsDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports